(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.section-header') || this;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.onViewportResize = this.setHeaderHeight.bind(this);
      window.addEventListener('resize', this.onViewportResize, { passive: true });

      if ('ResizeObserver' in window) {
        this.headerResizeObserver = new ResizeObserver(this.onViewportResize);
        this.headerResizeObserver.observe(this.header);
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(this.onViewportResize);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.onViewportResize);
      if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('pino-reserved-placement')) {
    customElements.define('pino-reserved-placement', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          if (!this.isConnected) return;
          const scope = this.closest('product-info');
          this.support = scope?.querySelector('[data-pino-reserved-support]');
          this.desktopAnchor = scope?.querySelector('[data-pino-reserved-desktop-anchor]');
          if (!this.support || !this.desktopAnchor) return;
          this.mobile = window.matchMedia('(max-width: 639px)');
          this.place = () => {
            const anchor = this.mobile.matches ? this : this.desktopAnchor;
            if (!anchor.isConnected || !this.support.isConnected) return;
            if (anchor.nextElementSibling !== this.support) anchor.after(this.support);
          };
          this.mobile.addEventListener('change', this.place);
          this.place();
        });
      }

      disconnectedCallback() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.mobile?.removeEventListener('change', this.place);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pino-link-panel"] && !Shopify.designMode) return;
  try {
    
  const pinoServiceMedia = window.matchMedia('(max-width: 749px)');
  const pinoServiceStates = new WeakMap();

  function syncPinoServices(root) {
    root.querySelectorAll('[data-pino-service-group]').forEach((group) => {
      const summary = group.querySelector('summary');
      if (!pinoServiceStates.has(group)) {
        pinoServiceStates.set(group, { mobileOpen: false });
        summary.addEventListener('click', (event) => {
          if (!pinoServiceMedia.matches) event.preventDefault();
        });
        group.addEventListener('toggle', () => {
          if (pinoServiceMedia.matches) pinoServiceStates.get(group).mobileOpen = group.open;
        });
      }
      group.open = pinoServiceMedia.matches ? pinoServiceStates.get(group).mobileOpen : true;
      if (pinoServiceMedia.matches) {
        summary.removeAttribute('tabindex');
        summary.removeAttribute('aria-disabled');
      } else {
        summary.setAttribute('tabindex', '-1');
        summary.setAttribute('aria-disabled', 'true');
      }
    });
  }

  syncPinoServices(document);
  pinoServiceMedia.addEventListener('change', () => syncPinoServices(document));
  document.addEventListener('shopify:section:load', (event) => syncPinoServices(event.target));

  } catch(e) { console.error(e); }
})();
})();
